import Hero from "../components/sections/Hero";
import WhatItDoes from "../components/sections/WhatItDoes";
import Features from "../components/sections/Features";
import Categories from "../components/sections/Categories";
import IndustriesMarquee from "../components/sections/IndustriesMarquee";
import WhoIsItFor from "../components/sections/WhoIsItFor";
import Benefits from "../components/sections/Benefits";
import WhyChoose from "../components/sections/WhyChoose";
import Showcase from "../components/sections/Showcase";
import Pricing from "../components/sections/Pricing";
import Testimonials from "../components/sections/Testimonials";
import FAQ from "../components/sections/FAQ";
import CTA from "../components/sections/CTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <WhatItDoes />
      <Features />
      <Categories />
      <IndustriesMarquee />
      <WhoIsItFor />
      <Benefits />
      <WhyChoose />
      <Showcase />
      <Testimonials />
      <Pricing />
      <FAQ />
      <CTA />
    </main>
  );
}
